/**
 * Implied density of one handling unit, in pounds per cubic foot.
 *
 * Two things read this: the freight class the shipment is quoted at, and the
 * warning that fires when the number is too high to be real freight. They have
 * to agree, so the arithmetic lives here rather than in both.
 *
 * Undefined when any axis is zero — there is no volume to divide by.
 */
export function lineItemsDensity(
  weight: number,
  length: number,
  width: number,
  height: number,
): number | undefined {
  if (length === 0 || width === 0 || height === 0) {
    return undefined;
  }

  const volumeInCubicFeet = (length * width * height) / (12 * 12 * 12);
  return weight / volumeInCubicFeet;
}
